import React, { FC, Fragment } from "react";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

import s from "./Button.less";

interface IProps {
  onClick?: (e) => void;
  data?;
  small?: boolean;
  isForm?: boolean;
  empty?: boolean;
  orange?: boolean;
  green?: boolean;
  withMargin?: boolean;
  onlyIcon?: boolean;
  txtBtn?: string;
  loading?: boolean;
  customClassName?: string;
  customIconClassName?: string;
  disabled?: boolean;
}

const Button: FC<IProps> = ({
  onClick,
  data,
  small = false,
  isForm = false,
  empty = false,
  orange = false,
  green = false,
  withMargin = false,
  onlyIcon = false,
  txtBtn,
  loading = false,
  customClassName = "",
  customIconClassName = "",
  children,
  disabled = false,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <button
        className={clsx({
          [s.btn]: true,
          [s.small]: small,
          [s.orange]: orange,
          [s.green]: green,
          [s.only_icon]: onlyIcon,
          [s.with_margin]: withMargin,
          [s.empty]: !small && empty,
          [s.small_empty]: small && empty,
          [customClassName]: true,
        })}
        type={isForm ? "submit" : "button"}
        onClick={onClick}
        disabled={disabled || loading}
        data-button_data={data}
      >
        {/*{loading ? (*/}
        {/*  <div className={s.loading} />*/}
        {/*) : (*/}
        <>
          {loading && <div className={s.loading} />}
          {children && (
            <div
              className={clsx(s.icon, {
                [customIconClassName]: true,
                [s.loadingChildren]: loading,
              })}
            >
              {children}
            </div>
          )}
          <span
            className={clsx({
              [s.loadingChildren]: loading,
            })}
          >
            {txtBtn}
          </span>
        </>
        {/*)}*/}
      </button>
    </>
  );
};
export default Button;
